import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { lazy } from 'react';
import { BarcodeType } from './types/type';
const LazyLoadedQRCode = lazy(() => import('./subcomponents/qr-code'));
const LazyLoadedOneDimensionalBarcode = lazy(() => import('./subcomponents/one-dimensional-barcode'));
const b = bemClassBuilder('v-barcode');
export const Barcode = observer(({ showLabel, value, type }) => {
    if (!value) {
        return null;
    }
    const isCode128Type = type === BarcodeType.Code128;
    const className = b.element(isCode128Type ? 'code128' : 'qr-code');
    const componentProps = { value, className };
    return (_jsxs("div", Object.assign({ className: b.block() }, { children: [isCode128Type ? (_jsx(LazyLoadedOneDimensionalBarcode, Object.assign({}, componentProps))) : (_jsx(LazyLoadedQRCode, Object.assign({}, componentProps))), showLabel && _jsx("span", Object.assign({ className: b.element('label') }, { children: value }))] })));
});
Barcode.displayName = 'Barcode';
